import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=6e45e1ad&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e45e1ad')) {
      api.createRecord('6e45e1ad', component.options)
    } else {
      api.reload('6e45e1ad', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=6e45e1ad&", function () {
      api.rerender('6e45e1ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Xt64G4IhKZhT/JS/imageCarousel.vue"
export default component.exports